<div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">

  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <h3 class="text-base font-semibold leading-6 text-gray-900 text-center">Google authentication in progress</h3>
      <div class="mt-2 text-sm text-gray-500 text-center">
        Please wait until we finish logging you in with your Google account. Once the process is finished, you will be automatically redirected to the proper place in the application.
      </div>
    </div>
  </div>


</div>
